/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'assets/js/modules/utils'], function(backbone, utils) {
    return backbone.Model.extend({
        defaults: {
            /** @var {OptionModel} option */
            option: null,
            /** @var {PricingCalcOptionValue[]} optionValues */
            optionValues: new backbone.Collection(),
            price: 0,
            salePrice: 0,
            vatRate: null,
            enabled: true,
            visible: true,
            changeable: true
        },

        /**
         * @param {string} optionValueName
         * @returns {PricingCalcOptionValueModel|undefined}
         */
        getOptionValue: function(optionValueName) {
            return this.get('optionValues').find(function(pricingCalcOptionValue) {
                return pricingCalcOptionValue.get('optionValue').get('name') === optionValueName;
            });
        },

        /**
         * @returns {PricingCalcOptionValueModel|undefined}
         */
        getSelectedOptionValue: function() {
            return this.get('optionValues').find(function(pricingCalcOptionValue) {
                return pricingCalcOptionValue.get('selected');
            });
        },

        /**
         * @returns {PricingCalcOptionValueModel|undefined}
         */
        getDefaultOptionValue: function() {
            return this.get('optionValues').find(function(pricingCalcOptionValue) {
                return pricingCalcOptionValue.get('default');
            });
        },

        /**
         * @param {boolean} [withVat]
         * @returns {number}
         */
        getPrice: function(withVat) {
            return withVat ? utils.applyVat(this.get('price'), this.get('vatRate')) : this.get('price');
        },

        /**
         * @param {boolean} [withVat]
         * @returns {number}
         */
        getSalePrice: function(withVat) {
            return withVat ? utils.applyVat(this.get('salePrice'), this.get('vatRate')) : this.get('salePrice');
        }
    });
});
